import React from 'react';

const Footer = props => {
  return (
    <div className="Footer">
      <p>&copy; 2020 - Jamison Cozart</p>
    </div>
  )
}

export default Footer;